import { Illustration_ } from 'src/api/db/apiProductImages'
import { OrderMap } from './types'

export const buildOrders = (list: Illustration_[]): OrderMap => {
  const map: OrderMap = {}
  list?.forEach(({ id, order }) => {
    map[id] = order || 0
  })
  return map
}

export const parseImageUrls = (urls: string | undefined): string[] => {
  if (!urls) return []
  return urls.split(', ').filter((url) => url.trim())
}

export const joinImageUrls = (urls: string[]): string => {
  return urls.join(', ')
}

export const removeImageUrl = (
  urls: string,
  urlToRemove: string
): string => {
  const urlList = parseImageUrls(urls)
  return joinImageUrls(urlList.filter((u) => u !== urlToRemove))
}

export const addImageUrl = (
  urls: string | undefined,
  newUrl: string
): string => {
  const currentUrls = parseImageUrls(urls)
  return joinImageUrls([...currentUrls, newUrl])
}

